let locales = {};
function checktLoaded(lang: string) {
  if (locales[lang] == null) locales[lang] = require(`./${lang}.json`);
}
export function get_i18n_CountryPack(lang: string) {
  checktLoaded(lang);
  return locales[lang].countries;
}
export function get_i18n_Country(lang: string, countryCode: string) {
  try {
    checktLoaded(lang);
    var result = locales[lang].countries[countryCode];
    if (typeof result == "string") {
      return result;
    } else {
      return result[0];
    }
  } catch {
    return countryCode;
  }
}
// const data = await import(`./${lang}.json`);
